export default __webpack_public_path__ + "static/media/UIB.0c04db76.jpg";